<script>
  import ColorGetterMixinBase from 'components/Dashboards/Widgets/mixins/ColorGetterMixinBase';

  export default {
    name: 'ColorGetterMixin',
    extends: ColorGetterMixinBase,
    methods: {
      getColorsListForEntities () {
        let groupingIdKey = this.grouping === 'label' ? 'label_name' : `${this.grouping}_id`;
        return this.statistics.map(item => this.colorGetter.getEntityColor(this.grouping, item[groupingIdKey]));
      }
    }
  };
</script>
